import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Download, Hotel } from "lucide-react";
import { QRCodeCanvas } from "qrcode.react";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { api, apiError } from "@/lib/api";

const conciergeUrl = (code) => `${window.location.origin}/?concierge=${code}`;

const downloadPoster = (qrCanvas, partner) => {
  const c = document.createElement("canvas");
  c.width = 1240;
  c.height = 1754;
  const g = c.getContext("2d");
  g.fillStyle = "#ffffff";
  g.fillRect(0, 0, c.width, c.height);
  g.fillStyle = "#000000";
  g.textAlign = "center";
  g.font = "900 64px Figtree, sans-serif";
  g.fillText("FLEETFLOW", 620, 170);
  g.font = "800 84px Figtree, sans-serif";
  g.fillText("Prenota il tuo transfer", 620, 330);
  g.font = "500 44px Figtree, sans-serif";
  g.fillStyle = "#3f3f46";
  g.fillText(partner, 620, 410);
  g.drawImage(qrCanvas, 270, 500, 700, 700);
  g.fillStyle = "#000000";
  g.font = "700 46px Figtree, sans-serif";
  g.fillText("Inquadra il QR con la fotocamera", 620, 1330);
  g.font = "400 36px Figtree, sans-serif";
  g.fillStyle = "#52525b";
  g.fillText("Aeroporto • Stazione • Città • A disposizione", 620, 1400);
  g.fillStyle = "#10B981";
  g.fillRect(0, 1560, c.width, 194);
  g.fillStyle = "#ffffff";
  g.font = "700 38px Figtree, sans-serif";
  g.fillText("Rete autisti NCC • Legge 21/1992", 620, 1672);
  const a = document.createElement("a");
  a.download = `fleetflow-concierge-${partner.toLowerCase().replace(/[^a-z0-9]+/g, "-")}.png`;
  a.href = c.toDataURL("image/png");
  a.click();
};

const QrItem = ({ item }) => {
  const ref = useRef(null);
  return (
    <div data-testid={`concierge-item-${item.code}`} className="ff-card p-4 flex flex-col items-center gap-3">
      <span className="font-bold text-white self-start flex items-center gap-2"><Hotel size={18} className="text-[#3B82F6]" /> {item.partner_name}</span>
      <div className="bg-white p-3 rounded-xl"><QRCodeCanvas ref={ref} value={conciergeUrl(item.code)} size={600} level="M" style={{ width: 180, height: 180 }} /></div>
      <span className="ff-code text-[11px] text-[#94A3B8] break-all text-center">{conciergeUrl(item.code)}</span>
      <button type="button" data-testid={`concierge-download-${item.code}`} onClick={() => downloadPoster(ref.current, item.partner_name)} className="ff-btn-primary w-full text-sm uppercase">
        <Download size={18} /> Scarica QR Code Concierge Hotel
      </button>
    </div>
  );
};

export const ConciergeSheet = ({ open, onClose }) => {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) api.get("/concierge").then((r) => setItems(r.data)).catch(() => {});
  }, [open]);

  const create = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.post("/concierge", { partner_name: name });
      setItems((list) => [data, ...list]);
      setName("");
      toast.success("QR Concierge generato");
    } catch (err) {
      toast.error(apiError(err, "Generazione non riuscita"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Sheet open={open} onOpenChange={(o) => !o && onClose()}>
      <SheetContent data-testid="concierge-sheet" className="ff-glass-panel w-full sm:max-w-md overflow-y-auto">
        <SheetHeader className="text-left">
          <SheetTitle className="ff-display text-2xl font-extrabold text-white">QR Concierge Hotel</SheetTitle>
          <SheetDescription className="text-[#94A3B8]">Stampa il QR per hotel e partner: i clienti inquadrano e inviano la richiesta di transfer direttamente sulla bacheca. Tu ricevi un avviso a ogni richiesta.</SheetDescription>
        </SheetHeader>
        <form onSubmit={create} className="mt-6 flex flex-col gap-3">
          <label className="block"><span className="ff-label">Nome hotel / partner</span>
            <input required minLength={2} data-testid="concierge-partner-input" className="ff-field" placeholder="Es. Hotel Excelsior Firenze" value={name} onChange={(e) => setName(e.target.value)} />
          </label>
          <button type="submit" disabled={saving} data-testid="concierge-create-button" className="ff-btn-secondary w-full uppercase text-sm border-[#3B82F6]">{saving ? "Generazione…" : "Genera QR Code"}</button>
        </form>
        <div className="mt-6 flex flex-col gap-4">{items.map((i) => <QrItem key={i.code} item={i} />)}</div>
      </SheetContent>
    </Sheet>
  );
};
